import { useState, useEffect } from "react";
import { Button, Divider, Input, Modal } from "antd";
import { Form, Select, Row, Col, Switch, Slider } from "antd";
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)

const { Option } = Select;
const generateMarks = (maxLever) => {
  const baseLevels = [1, 3, 5, 10, 20, 50, 100];

  // Lấy các mốc phù hợp <= maxLever
  let levels = baseLevels.filter((lvl) => lvl <= maxLever);

  // Nếu maxLever không có trong danh sách và < 100 thì thêm vào
  if (!levels.includes(maxLever)) {
    levels.push(maxLever);
  }

  // Tạo marks với key là chính giá trị thực tế
  const marks = {};
  levels.forEach((level) => {
    marks[level] = `${level}X`;
  });

  return marks;
};

const ModalContent = ({
  unFollowPairs,
  createFollowPair,
  isModalShowed,
  toggleConfigModal,
  followPairInfor,
}) => {
  const [form] = Form.useForm();
  const [selectedPair, setSelectedPair] = useState(null);
  const [tpType, setTpType] = useState("TP/SL");

  const onSubmit = (values: any) => {
    createFollowPair(values);
    toggleConfigModal({});
  };
  useEffect(() => {
    if (followPairInfor) {
      form.setFieldsValue({
        symbol: followPairInfor.symbol,
        instType: followPairInfor.instType,
        instId: followPairInfor.instId,
        minSz: followPairInfor.minSz,
        tickSz: followPairInfor.tickSz,
        lotSz: followPairInfor.lotSz,
        ctVal: followPairInfor.ctVal,
        selectedRowKeys: followPairInfor.selectedRowKeys,
        type: followPairInfor.type,
        close: followPairInfor.close,
        close_1m: followPairInfor.close_1m,
        close_5m: followPairInfor.close_5m,
        close_15m: followPairInfor.close_15m,
        close_50m: followPairInfor.close_50m,
        close_1h: followPairInfor.close_1h,
        close_2h: followPairInfor.close_2h,
        close_4h: followPairInfor.close_4h,
        close_6h: followPairInfor.close_6h,

        pos_side: followPairInfor.pos_side,
        candle_group: followPairInfor.candle_group,
        entry_percent: followPairInfor.entry_percent,
        timeframe:followPairInfor.timeframe,
        amount: followPairInfor.amount,
        auto_increment_amount_percent:
        followPairInfor.auto_increment_amount_percent,
        order_time_limit: followPairInfor.order_time_limit,
        max_order_amount: followPairInfor.max_order_amount,
        auto_increment_entry_percent:
        followPairInfor.auto_increment_entry_percent,
        auto_reduce_tp_percent: followPairInfor.auto_reduce_tp_percent,
        tp_percent: followPairInfor.tp_percent,
        sl_percent: followPairInfor.sl_percent,
        status: followPairInfor.status,
        is_adaptive: followPairInfor.is_adaptive,
        is_reverse: followPairInfor.is_reverse,
        enable_safe_mode: followPairInfor.enable_safe_mode,
        auto_enable: followPairInfor.auto_enable,
        enable_dca_cutloss: followPairInfor.enable_dca_cutloss,
        auto_oc: followPairInfor.auto_oc,
        boll_mode: followPairInfor.boll_mode,
        margin_leverage_ratio:
          followPairInfor.margin_leverage_ratio > 0
            ? followPairInfor.margin_leverage_ratio
            : 1,
        tp_type: followPairInfor.tp_type,
        entry_price: followPairInfor.entry_price,
        tp_price: followPairInfor.tp_price,
        trailing_trigger_ratio: followPairInfor.trailing_trigger_ratio,
        trailing_callback_ratio: followPairInfor.trailing_callback_ratio,
        trailing_reduce: followPairInfor.trailing_reduce,
        trailing_increase: followPairInfor.trailing_increase,
        trailing_top_peak: followPairInfor.trailing_top_peak,
        trailing_trigger_px: followPairInfor.trailing_trigger_px,

        dca_down_trigger: followPairInfor.dca_down_trigger,
        dca_trigger_increase:followPairInfor.dca_trigger_increase,
        dca_amount: followPairInfor.dca_amount,
        amount_dca_start: followPairInfor.amount_dca_start,
        amount_dca_min: followPairInfor.amount_dca_min,
        amount_dca_reduce: followPairInfor.amount_dca_reduce,
        dca_max_count: followPairInfor.dca_max_count,
        reduce_pos_from: followPairInfor.reduce_pos_from,
        reduce_pos_pnl: followPairInfor.reduce_pos_pnl,
        dca_gap_time: followPairInfor.dca_gap_time,
        
        pos_avgPx: followPairInfor.pos_avgPx,
        next_dca_time: followPairInfor.next_dca_time,

        safe_band_down_ratio: followPairInfor.safe_band_down_ratio,
        safe_band_up_ratio: followPairInfor.safe_band_up_ratio,
        bb_timeframe: followPairInfor.bb_timeframe,
        bb_upband: followPairInfor.bb_upband,
        bb_downband: followPairInfor.bb_downband,
      });
      const selected = unFollowPairs.find(
        (pair) => pair.symbol === followPairInfor.symbol
      );
      setSelectedPair(selected);
      setTpType(followPairInfor.tp_type);
    }
  }, [followPairInfor]);

  return (
    <Modal
      centered
      title="CREATE TRADE CONFIGS"
      open={isModalShowed}
      onCancel={() => toggleConfigModal({})}
      footer={[null]}
    >
      <Form
        form={form}
        size="large"
        name="folowpair_config_form"
        layout="vertical"
        onFinish={onSubmit}
      >
        {(!followPairInfor.selectedRowKeys ||
          followPairInfor.selectedRowKeys.length === 0) && (
          <Form.Item name="symbol" label="Choose a symbol *">
            <Select
              showSearch
              placeholder="Choose a symbol"
              style={{ width: "100%" }}
              onChange={(value) => {
                const selected = unFollowPairs.find(
                  (pair) => pair.symbol === value
                );
                form.setFieldValue('instId', selected?.instId);
                form.setFieldValue('instType', selected?.instType);
                form.setFieldValue('minSz', selected?.minSz);
                form.setFieldValue('tickSz', selected?.tickSz);
                form.setFieldValue('lotSz', selected?.lotSz);
                form.setFieldValue('ctVal', selected?.ctVal);
                form.setFieldValue('lever', selected?.lever);
                form.setFieldValue('close_1m', selected?.close_1m);
                form.setFieldValue('close_5m', selected?.close_5m);
                form.setFieldValue('close_15m', selected?.close_15m);
                form.setFieldValue('close_30m', selected?.close_30m);
                form.setFieldValue('close_1h', selected?.close_1h);
                form.setFieldValue('close_2h', selected?.close_2h);
                form.setFieldValue('close_4h', selected?.close_4h);
                form.setFieldValue('close_6h', selected?.close_6h);
                console.log(selected?.instId );
                setSelectedPair(selected);
              }}
            >
              {unFollowPairs.map((pair) => (
                <Option key={pair.symbol} value={pair.symbol}>
                  {pair.symbol}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}
        {followPairInfor.selectedRowKeys &&
          followPairInfor.selectedRowKeys.length > 0 && (
            <Form.Item
              name="selectedRowKeys"
              hidden={true}
              label="FollowPairIds"
            >
              <Input type="text" placeholder="Enter OC" />
            </Form.Item>
          )}
        <Form.Item name="type" hidden={true}>
          <Input />
        </Form.Item>
        
        <Form.Item name="instType" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="instId" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="minSz" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="tickSz" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="lotSz" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="ctVal" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="lever" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="close_1m" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="close_5m" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="close_15m" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="close_30m" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item name="close_1h" hidden={true}>
          <Input />
        </Form.Item>
         <Form.Item name="close_2h" hidden={true}>
          <Input />
        </Form.Item>
         <Form.Item name="close_4h" hidden={true}>
          <Input />
        </Form.Item>
         <Form.Item name="close_6h" hidden={true}>
          <Input />
        </Form.Item>

        <div hidden={false}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="pos_side" label="Post side">
                <Select
                  showSearch
                  placeholder="Choose a post side"
                  style={{ width: "100%" }}
                >
                  <Option key="long" value="long">
                    LONG
                  </Option>
                  {followPairInfor.type != "spot" && (
                    <Option key="short" value="short">
                      SHORT
                    </Option>
                  )}
                </Select>
              </Form.Item>
            </Col>
            
          </Row>
        </div>

        <Row gutter={16}>
          <Col span={12}>
          <Form.Item name="amount" label="Amounts">
                  <Input type="number" placeholder="Enter amounts" />
                </Form.Item>
          </Col>
          <Col span={12}>
                      <Form.Item name="timeframe" label="TimeFrame">
                        <Select
                          placeholder="Choose a timeframe"
                          style={{ width: "100%" }}
                        >
                          <Option value='3s'>3s</Option>
                          <Option value='1m'>1m</Option>
                          <Option value='5m'>5m</Option>
                          <Option value='15m'>15m</Option>
                          <Option value='30m'>30m</Option>
                          <Option value='1h'>1h</Option>
                          <Option value='2h'>2h</Option>
                          <Option value='4h'>4h</Option>
                          <Option value='6h'>6h</Option>
                        </Select>
                      </Form.Item>
                    </Col>
        </Row>
        
        <div
          style={{
            margin: "-15px 0px 0px 15px",
            fontSize: "xx-small",
            fontWeight: 700,
            color: "#b46868",
          }}
        >
          Min sz: {selectedPair ? selectedPair.minSz : 0}{" "}
          {selectedPair ? selectedPair.asset : ""} ~{" "}
          {selectedPair
            ? Math.ceil(selectedPair.minSz * selectedPair.close * 1.1)
            : 0}{" "}
          USDT
        </div>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="entry_percent"
              label="OC"
              rules={[
                {
                  pattern: /^-?\d+(\.\d{1,2})?$/,
                  message:
                    "Please enter a valid OC value with up to 2 decimal places.",
                },
              ]}
            >
              <Input
                type="number"
                step={0.01}
                min={0}
                max={10}
                placeholder="Enter OC"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
                name="auto_increment_entry_percent"
                label="Auto increase OC"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid Auto increase OC value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input
                  type="number"
                  min={0}
                  max={50}
                  placeholder="Enter auto increase OC"
                />
              </Form.Item>
            
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
                name="dca_down_trigger"
                label="DCA trigger"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA trigger value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter DCA trigger" />
              </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
                name="dca_trigger_increase"
                label="trigger inc"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA trigger increase value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter DCA trigger increase" />
              </Form.Item>
          </Col>

          

          <Col span={8}>
            <Form.Item
                name="dca_gap_time"
                label="gap time"
              >
                <Input type="number" placeholder="Enter DCA gap time" />
              </Form.Item>
          </Col>
          
          {/* <Col span={12}>
            <Form.Item
              name="auto_increment_amount_percent"
              label="Auto amount percent"
              rules={[
                {
                  pattern: /^-?\d+(\.\d{1,2})?$/,
                  message:
                    "Please enter a valid Reduce value with up to 2 decimal places.",
                },
              ]}
            >
              <Input
                type="number"
                min={0}
                max={20}
                placeholder="Enter auto amounts percent"
              />
            </Form.Item>
          </Col> */}
        </Row>

      {/* <Row gutter={16}>
          <Col span={12}>
            <Form.Item
                name="dca_amount"
                label="DCA Amount"
              >
                <Input type="number" placeholder="Enter DCA trigger" />
              </Form.Item>
          </Col>
          
      </Row> */}

      <div
        style={{
          margin: "-15px 0px 0px 15px",
          fontSize: "xx-small",
          fontWeight: 400,
          color: "#b46868",
        }}
      >
        <div style={{ display: "flex", gap: "8px", marginBottom: "4px" }}>
          <div style={{ flex: 1 }}>
            Entry/Close: {Number(followPairInfor.pos_avgPx).toString() ?? 'N/A'} / {Number(followPairInfor.close).toString() ?? 'N/A'}
          </div>

          <div style={{ flex: 1 }}>
            Amount: [{followPairInfor?.dca_count ?? '0'}] - $
            {(() => {
              if (!followPairInfor) return '0';

              if (followPairInfor.type === 'spot') {
                return followPairInfor.total_usdt !== undefined
                  ? Number(followPairInfor.total_usdt).toFixed(1)
                  : '0';
              }

              const avgPx = Number(followPairInfor.pos_avgPx ?? 0);
              const pos = Number(followPairInfor.pos_pos ?? 0);
              const ctVal = Number(followPairInfor.ctVal ?? 1);
              const calculated = avgPx * pos * ctVal;

              return calculated.toFixed(1);
            })()}
          </div>
        </div>

        <div style={{ display: "flex", gap: "8px" }}>
          <div style={{ flex: 1 }}>
            profit: {followPairInfor.order_current_profit !== undefined 
              ? `${Number(followPairInfor.order_current_profit).toFixed(1)}%` 
              : 'N/A'} 
            (
              ${followPairInfor?.total_usdt !== undefined 
                ? Number(followPairInfor.total_usdt * followPairInfor.order_current_profit / 100).toFixed(1) 
                : '0'}
            )
          </div>

          <div style={{ flex: 1 }}>
            DCA:{" "}
            {followPairInfor?.next_dca_time && followPairInfor?.next_dca_px ? (
              (() => {
                const dcaTime = dayjs.utc(followPairInfor.next_dca_time).tz('Asia/Ho_Chi_Minh');
                const now = dayjs().tz('Asia/Ho_Chi_Minh');
                const dcaPx = parseFloat(followPairInfor.next_dca_px).toFixed(2);

                if (dcaTime.isBefore(now) || dcaTime.isSame(now)) {
                  return <span>{dcaPx} (Sẵn sàng)</span>;
                }

                return <span>{dcaPx} ({dcaTime.fromNow()})</span>;
              })()
            ) : (
              'N/A'
            )}
          </div>
        </div>

        {/* DCA Stack row */}
        {(() => {
          const rawStack = followPairInfor?.dca_stack;
          if (!rawStack) return null;
          let stack: { px: string; vol: string }[] = [];
          try {
            stack = typeof rawStack === 'string' ? JSON.parse(rawStack) : rawStack;
          } catch {
            return null;
          }
          if (!Array.isArray(stack) || stack.length === 0) return null;

          const currentClose = Number(followPairInfor.close ?? 0);

          return (
            <div style={{ marginTop: '4px' }}>
              <div style={{ marginBottom: '2px', fontWeight: 600, color: '#8b8b8b' }}>
                DCA Stack ({stack.length}):
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '4px',
                  overflowX: 'auto',
                  paddingBottom: '2px',
                  flexWrap: 'nowrap',
                }}
              >
                {stack.map((item, idx) => {
                  const px = parseFloat(item.px);
                  const vol = parseFloat(item.vol);
                  const chipColor = vol > 0 ? '#27ae60' : vol < 0 ? '#c0392b' : '#555';
                  return (
                    <div
                      key={idx}
                      style={{
                        display: 'inline-flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: '1px 4px',
                        borderRadius: '3px',
                        border: `1px solid ${chipColor}`,
                        color: chipColor,
                        fontSize: '9px',
                        whiteSpace: 'nowrap',
                        minWidth: '44px',
                        lineHeight: '1.3',
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{px}</span>
                      <span style={{ opacity: 0.75 }}>${(parseFloat(item.vol) * parseFloat(item.px) * Number(followPairInfor.ctVal ?? 1)).toFixed(0)}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })()}
      </div>


        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
                name="amount_dca_start"
                label="V start (%)"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA amount start percent value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter DCA amount start" />
              </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
                name="amount_dca_reduce"
                label="V reduce (%)"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA reduce percent value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter DCA reduce" />
              </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
                name="amount_dca_min"
                label="V min (%)"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA amount min percent value with up to 2 decimal places.",
                  },
                  ]}
              >
                <Input type="number" placeholder="Enter DCA min" />
              </Form.Item>
          </Col>
        </Row>
        <div
          style={{
            margin: "-15px 0px 0px 15px",
            fontSize: "xx-small",
            fontWeight: 400,
            color: "#b46868",
          }}
        >
            DCA Volumes:&nbsp;
            {(() => {
              const amount = Number(form.getFieldValue("amount") ?? 0);
              const start = Number(form.getFieldValue("amount_dca_start") ?? 0);
              const reduce = Number(form.getFieldValue("amount_dca_reduce") ?? 0);
              const min = Number(form.getFieldValue("amount_dca_min") ?? 0);
              const maxCount = Number(form.getFieldValue("dca_max_count") ?? 5);

              if (!amount || !start || maxCount <= 0) return "N/A";

              const volumes: string[] = [];
              for (let i = 0; i < maxCount; i++) {
                const factor = Math.pow(1 - reduce / 100, i);
                const percent = Math.max(min / 100, factor * start / 100);
                const vol = amount * percent;
                volumes.push(`$${vol.toFixed(2)}`);
              }

              return volumes.join(" → ");
            })()}
        </div>
        <Row gutter={16}>
          

          <Col span={8}>
            <Form.Item
                name="dca_max_count"
                label="max count"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA trigger value with up to 2 decimal places.",
                  },
                  ]}
              >
                <Input type="number" placeholder="Enter DCA gap time" />
              </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
                name="reduce_pos_from"
                label="Reduce from"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA trigger value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter DCA trigger" />
              </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
                name="reduce_pos_pnl"
                label="Reduce pnl"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid DCA trigger value with up to 2 decimal places.",
                  },
                  ]}
              >
                <Input type="number" placeholder="Enter DCA gap time" />
              </Form.Item>
          </Col>
        </Row>
        <div
          style={{
            margin: "-15px 0px 0px 15px",
            fontSize: "xx-small",
            fontWeight: 400,
            color: "#b46868",
          }}
        >
            <div style={{ flex: 1 }}>
              REDUCE:{" "}
              {followPairInfor?.next_dca_time && followPairInfor?.next_dca_cutloss_px ? (
                (() => {
                  const dcaTime = dayjs.utc(followPairInfor.next_dca_time).tz('Asia/Ho_Chi_Minh');
                  const now = dayjs().tz('Asia/Ho_Chi_Minh');
                  const dcaPx = parseFloat(followPairInfor.next_dca_cutloss_px).toFixed(2);

                  if (dcaTime.isBefore(now) || dcaTime.isSame(now)) {
                    return <span>{dcaPx} (Sẵn sàng)</span>;
                  }

                  return <span>{dcaPx} ({dcaTime.fromNow()})</span>;
                })()
              ) : (
                'N/A'
              )}
            </div>
        </div>
       

      
        <Divider style={{ margin: "16px 0" }} />

        <div>
          {/* Dropdown Tp Type */}
          <Form.Item name="tp_type" label="Tp Type">
            <Select
              value={tpType}
              onChange={(value) => setTpType(value)} // Cập nhật trạng thái Tp Type
              placeholder="Choose Tp Type"
              style={{ width: "100%" }}
            >
              <Option value="TPSL">TP/SL</Option>
              <Option value="PriceAction">PriceAction</Option>
              <Option value="TrailingStop">Trailing Stop</Option>
              <Option value="BollingerBand">Bollinger Band</Option>
              <Option value="MATrend">EMA Line</Option>
            </Select>
          </Form.Item>

          <div hidden={tpType !== "TPSL"}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="auto_reduce_tp_percent"
                  label="Reduce"
                  rules={[
                    {
                      pattern: /^-?\d+(\.\d{1,2})?$/,
                      message:
                        "Please enter a valid Reduce value with up to 2 decimal places.",
                    },
                  ]}
                >
                  <Input type="number" placeholder="Enter reduce" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="tp_percent"
                  label="Take profit"
                  rules={[
                    {
                      pattern: /^-?\d+(\.\d{1,2})?$/,
                      message:
                        "Please enter a valid Reduce value with up to 2 decimal places.",
                    },
                  ]}
                >
                  <Input type="number" placeholder="Enter take profit" />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div hidden={tpType !== "PriceAction"}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item name="entry_price" label="Entry Price">
                  <Input type="number" placeholder="Enter entry price" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="tp_price" label="Tp Price">
                  <Input type="number" placeholder="Enter tp price" />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div hidden={tpType !== "TrailingStop"}>
            <div
              style={{
                margin: "-15px 0px 0px 15px",
                fontSize: "xx-small",
                fontWeight: 400,
                color: "#b46868",
              }}
            >
              <Row gutter={16}>
                <Col span={24}>
                  close/Top: {Number(followPairInfor.close).toString() ?? 'N/A'} / {Number(followPairInfor.trailing_top_peak).toString() ?? 'N/A'} (
                    {
                      followPairInfor.close && followPairInfor.trailing_top_peak
                        ? `${((Number(followPairInfor.close) - Number(followPairInfor.trailing_top_peak)) / Number(followPairInfor.trailing_top_peak) * 100).toFixed(2)}%`
                        : 'N/A'
                    }
                  )
                </Col>
                
              </Row>

            </div>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="trailing_trigger_ratio"
                  label="Trailing trigger ratio"
                >
                  <Input type="number" placeholder="Enter trigger ratio" />
                </Form.Item>

                <div
              style={{
                margin: "-15px 0px 0px 15px",
                fontSize: "xx-small",
                fontWeight: 400,
                color: "#b46868",
              }}
            >
              <Row gutter={16}>
                <Col span={24}>
                  trigger: {Number(followPairInfor.trailing_trigger_px).toString() ?? 'N/A'} (
                    {
                      followPairInfor.close && followPairInfor.trailing_trigger_px
                        ? `${((Number(followPairInfor.close) - Number(followPairInfor.trailing_trigger_px)) / Number(followPairInfor.trailing_trigger_px) * 100).toFixed(2)}%`
                        : 'N/A'
                    }
                  )
                </Col>
                
              </Row>

            </div>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="trailing_callback_ratio"
                  label="Trailing callback ratio"
                >
                  <Input type="number" placeholder="Enter callback ratio" />
                </Form.Item>
                <Row gutter={16}>
                <Col span={24}>
                  callback: {Number(followPairInfor.trailing_trigger_px).toString() ?? 'N/A'} (
                    {
                      followPairInfor.close && followPairInfor.trailing_trigger_px
                        ? `${((Number(followPairInfor.close) - Number(followPairInfor.trailing_trigger_px)) / Number(followPairInfor.trailing_trigger_px) * 100).toFixed(2)}%`
                        : 'N/A'
                    }
                  )
                </Col>
                
              </Row>
              </Col>
              <Col span={12}>
                <Form.Item name="trailing_reduce" label="Trigger reduce">
                  <Input type="number" placeholder="Enter trigger reduce" />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item name="trailing_increase" label="Trigger increase">
                  <Input type="number" placeholder="Enter trigger increase" />
                </Form.Item>
              </Col>
              
            </Row>
          </div>

          <div hidden={tpType !== "BollingerBand"}>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="bb_timeframe" label="TimeFrame">
                  <Select
                    placeholder="Choose a timeframe"
                    style={{ width: "100%" }}
                  >
                    <Option value={1}>1m</Option>
                    <Option value={15}>15m</Option>
                    <Option value={30}>30m</Option>
                    <Option value={60}>1h</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="bb_upband" label="U Band %">
                  <Input type="number" placeholder="Enter Up Band" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="bb_downband" label="D Band %">
                  <Input type="number" placeholder="Enter Down Band" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>

        <Divider style={{ margin: "16px 0" }} />

       

        <Row gutter={24}>
          <Col span={8}>
            <Form.Item name="safe_band_up_ratio" label="Safe U %">
              <Input type="number" placeholder="Enter safe up %" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="safe_band_down_ratio" label="Safe D %">
              <Input type="number" placeholder="Enter safe down %" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
                name="sl_percent"
                label="Stop loss"
                rules={[
                  {
                    pattern: /^-?\d+(\.\d{1,2})?$/,
                    message:
                      "Please enter a valid Reduce value with up to 2 decimal places.",
                  },
                ]}
              >
                <Input type="number" placeholder="Enter take loss" />
              </Form.Item>
            
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={0}>
            <Row style={{ alignItems: "baseline" }}>
              <Form.Item name="is_reverse" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "5px" }}>Reverse</span>
            </Row>
          </Col>

          <Col span={0}>
            <Row style={{ alignItems: "baseline" }} hidden={true}>
              <Form.Item name="is_adaptive" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "5px" }}>Adaptive</span>
            </Row>
          </Col>
          <Col span={8}>
            <Row style={{ alignItems: "baseline" }}>
              <Form.Item name="status" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "5px" }}>Status</span>
            </Row>
          </Col>

          <Col span={8}>
            <Row style={{ alignItems: "baseline" }}>
              <Form.Item name="enable_safe_mode" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "4px" }}>Safe</span>
            </Row>
          </Col>
          <Col span={8}>
            <Row style={{ alignItems: "baseline" }}>
              <Form.Item name="auto_enable" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "4px" }}>A-Enable</span>
            </Row>
          </Col>
          <Col span={8}>
            <Row style={{ alignItems: "baseline" }}>
              <Form.Item name="enable_dca_cutloss" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "4px" }}>Dca loss</span>
            </Row>
          </Col>

          {/* <Col span={8}>
            <Row style={{ alignItems: "baseline" }}>
              <Form.Item name="boll_mode" valuePropName="checked">
                <Switch size="small" />
              </Form.Item>
              <span style={{ marginLeft: "4px" }}>Boll</span>
            </Row>
          </Col> */}
        </Row>

        {followPairInfor.type === "margin" && (
          <>
            <Form.Item name="margin_leverage_ratio">
              <Slider
                marks={{
                  1: "1X",
                  2: "2X",
                  3: "3x",
                  4: "4X",
                  5: "5X",
                  10: "10x",
                }}
                min={1}
                max={
                  selectedPair == null || selectedPair.lever > 5
                    ? 5
                    : selectedPair.lever
                }
              />
            </Form.Item>
          </>
        )}
        {followPairInfor.type === "derivatives" && selectedPair && (
          <Form.Item name="margin_leverage_ratio">
            <Slider
              min={1}
              max={selectedPair.lever}
              step={null} 
              marks={generateMarks(selectedPair.lever)}
            />
          </Form.Item>
        )}

        <Form.Item
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Button
            style={{ marginRight: "10px" }}
            onClick={() => toggleConfigModal({})}
          >
            CANCEL
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            {followPairInfor &&
            (followPairInfor.symbol || followPairInfor.selectedRowKeys)
              ? "UPDATE"
              : "CREATE"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalContent;
